import { useAuth0 } from '@auth0/auth0-react';
import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';
import YellowBorderButton from 'components/buttons/YellowBorderButton';
import YellowButton from 'components/buttons/YellowButton';
import ManageSubscription from './ManageSubscription';

const ActionButtons = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('desktop'));

  const { loginWithRedirect, isAuthenticated } = useAuth0();

  return (
    <Box width="85%" position="absolute" bottom={isSmallScreen ? '120px' : '172px'}>
      {isAuthenticated ? (
        <Box width="100%">
          <ManageSubscription buttonTitle="Get Pro" />
        </Box>
      ) : (
        <Stack
          flexDirection={{ mobile: 'column', tablet: 'row' }}
          justifyContent={{ mobile: 'center', tablet: 'space-between' }}
          gap={2}
        >
          <YellowBorderButton
            sx={{
              width: { mobile: '100%', tablet: '120px' },
              height: { mobile: '56px', tablet: '44px' },
              borderRadius: '200px',
            }}
            onClick={() => loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } })}
          >
            Sign Up
          </YellowBorderButton>
          <YellowButton
            sx={{
              width: { mobile: '100%', tablet: '120px' },
              height: { mobile: '56px', tablet: '44px' },
              borderRadius: '200px',
            }}
            onClick={() => loginWithRedirect()}
          >
            Log In
          </YellowButton>
        </Stack>
      )}
    </Box>
  );
};

export default ActionButtons;
